import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import UserService from "../services/UserService";

const useUserService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new UserService(client);
  }, [client]);

  return service;
};

export default useUserService;
